import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchExportation(exportation_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/manage_exportation/fetch_exportation/${exportation_id}`
    );
  },
  fetchAvailableToExportContainers(
    agro_exporter_process_id,
    exportation_id = null
  ) {
    let route =
      "agro_exporter/production/basic_container_export/manage_exportation/fetch_available_to_export_containers";
    if (exportation_id) {
      return RequesterV1.get(
        `${route}/${agro_exporter_process_id}/${exportation_id}`
      );
    } else {
      return RequesterV1.get(`${route}/${agro_exporter_process_id}`);
    }
  },
  fetchExportationFiles(exportation_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/exportation_attachments/list_exportation_files/${exportation_id}`
    );
  },
  fetchExportationAttachments(exportation_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/exportation_attachments/${exportation_id}`
    );
  },
  createExportation(
    agro_exporter_process_id,
    booking_code,
    departured_at,
    arrived_at,
    origin_export_id,
    destination_export_id,
    shipping_line_id,
    ship,
    status_id,
    exportation_type_id,
    containers
  ) {
    return RequesterV1.post(
      `agro_exporter/production/basic_container_export/manage_exportation/create/${agro_exporter_process_id}`,
      {
        exportation: {
          booking_code: booking_code,
          departured_at: departured_at,
          arrived_at: arrived_at,
          origin_export_id: origin_export_id,
          destination_export_id: destination_export_id,
          shipping_line_id: shipping_line_id,
          ship: ship,
          status_id: status_id,
          exportation_type_id: exportation_type_id
        },
        containers: containers
      }
    );
  },
  createExportationAttachment(
    exportation_id,
    exporter_process_exportation_file_id,
    file
  ) {
    let formData = new FormData();
    formData.append("exportation_attachment[exportation_attach]", file);
    formData.append(
      "exportation_attachment[exporter_process_exportation_file_id]",
      exporter_process_exportation_file_id
    );
    return RequesterV1.post(
      `agro_exporter/production/basic_container_export/exportation_attachments/create/${exportation_id}/`,
      formData
    );
  },
  updateExportation(
    exportation_id,
    booking_code,
    departured_at,
    arrived_at,
    origin_export_id,
    destination_export_id,
    shipping_line_id,
    ship,
    status_id,
    exportation_type_id,
    containers
  ) {
    return RequesterV1.post(
      `agro_exporter/production/basic_container_export/manage_exportation/update/${exportation_id}`,
      {
        exportation: {
          booking_code: booking_code,
          departured_at: departured_at,
          arrived_at: arrived_at,
          origin_export_id: origin_export_id,
          destination_export_id: destination_export_id,
          shipping_line_id: shipping_line_id,
          ship: ship,
          status_id: status_id,
          exportation_type_id: exportation_type_id
        },
        containers: containers
      }
    );
  },
  destroyExportation(exportation_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/manage_exportation/destroy/${exportation_id}`
    );
  },
  destroyExportationAttachment(exportation_attachment_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/exportation_attachments/destroy/${exportation_attachment_id}`
    );
  },
  downloadExportationRepXlsx(exportation_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/manage_exportation/exportation_rep_xlsx/${exportation_id}`,
      { responseType: "blob" }
    );
  },
  downloadExportationAttachment(exportation_attachment_id) {
    return RequesterV1.get(
      `agro_exporter/production/basic_container_export/exportation_attachments/download/${exportation_attachment_id}`,
      { responseType: "blob" }
    );
  }
};
